import { useLang } from "@/context/LanguageContext";
import { Languages } from "lucide-react";

export default function LanguageToggle({ variant = "default" }) {
  const { lang, setLang } = useLang();
  const next = lang === "en" ? "es" : "en";
  const onDark = variant === "dark";
  return (
    <button
      data-testid="language-toggle"
      onClick={() => setLang(next)}
      aria-label={`Switch language to ${next === "es" ? "Español" : "English"}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-sm text-xs font-semibold transition-all duration-200 ${
        onDark
          ? "text-white/90 hover:bg-white/10"
          : "text-[#4B5950] hover:bg-[#EAF0EA] border border-[#DCE3DD]"
      }`}
    >
      <Languages className="h-4 w-4" />
      {lang === "en" ? "EN" : "ES"}
    </button>
  );
}
